export default __webpack_public_path__ + "static/media/filter-list.77e674cf.svg";